'use strict';

var bls12381KeyPair = require('@mattrglobal/bls12381-key-pair');
var base58 = require('multiformats/bases/base58');
var types = require('../../lib/types');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateBls12381KeyPair = /* @__PURE__ */ __name(async ({ seed }) => {
  if (!seed) {
    throw new Error("Invalid seed");
  }
  const keys = await bls12381KeyPair.Bls12381G2KeyPair.generate({
    seed
  });
  const bbsKeyPair = {
    type: types.VerificationType.Bls12381G2Key2020,
    seed,
    seedBase58: base58.base58btc.encode(seed).slice(1),
    privateKey: keys.privateKeyBuffer,
    privateKeyBase58: keys.privateKey,
    publicKey: keys.publicKeyBuffer,
    publicKeyBase58: keys.publicKey
  };
  return bbsKeyPair;
}, "generateBls12381KeyPair");

exports.generateBls12381KeyPair = generateBls12381KeyPair;
